/**
 * Ordenação da aba Grupos salva no store do ra-core (localStorage), sem React
 * (mesmo motivo de `filtrosAvancados.ts`: regra precisa de teste direto, não
 * de clique na tela).
 *
 * Desde a reunião de 14/10/2026 a lista só ordena por estes campos; a chance
 * de contemplação (BCB), lance, contemplados e progresso saíram da tela.
 */

export const CAMPOS_DE_ORDENACAO = [
  'group_number',
  'vacancies',
  'prazo',
  'credit_min',
  'credit_max',
] as const;

export type CampoDeOrdenacao = (typeof CAMPOS_DE_ORDENACAO)[number];

export interface Ordenacao {
  campo: CampoDeOrdenacao;
  ordem: 'asc' | 'desc';
}

export const ORDENACAO_PADRAO: Ordenacao = { campo: 'group_number', ordem: 'asc' };

const objeto = (v: unknown): Record<string, unknown> =>
  v != null && typeof v === 'object' ? (v as Record<string, unknown>) : {};

/**
 * O que veio do localStorage pode ser de uma versão antiga da tela (ex.: a
 * ordenação por chance), ou lixo. Campo desconhecido volta ao padrão em vez
 * de deixar a lista sem ordem.
 */
export const normalizarOrdenacao = (salvo: unknown): Ordenacao => {
  const o = objeto(salvo);
  const campo = (CAMPOS_DE_ORDENACAO as readonly unknown[]).includes(o.campo)
    ? (o.campo as CampoDeOrdenacao)
    : ORDENACAO_PADRAO.campo;
  const ordem = o.ordem === 'desc' || o.ordem === 'asc' ? o.ordem : ORDENACAO_PADRAO.ordem;
  return { campo, ordem };
};
